import { Dictionary } from 'src/app/core/model/dictionary';
export class InsurerEdit
{
    public id = null;
    public name = '';
    public contactName = '';
    public contactPhone = '';
    public contactEmail = '';
    public url = '';
    public invoiceNumberSuffix = '';    
    public feeSchedules: Dictionary[] = [];
    public active = true;
}
